import { Button, Flex, Form, Radio } from "antd";
import CustomModal from "../../../components/CustomModal";

interface OtpChannelModalProps {
  open: boolean;
  onClose: () => void;
  onFinish: (values: { otpChannel: "email" | "phone" }) => void;
  isLoading: boolean;
  email?: string;
  phone?: string;
}

export default function OtpChannelModal({
  open,
  onClose,
  onFinish,
  isLoading,
  email,
  phone,
}: OtpChannelModalProps) {
  const [form] = Form.useForm();
  const selectedChannel = Form.useWatch("otpChannel", form);

  return (
    <CustomModal
      handleClose={onClose}
      title="ওটিপি পাঠানোর মাধ্যম"
      open={open}
      width={400}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="otpChannel"
          rules={[{ required: true, message: "ওটিপি পাঠানোর মাধ্যম দিতে হবে!" }]}
          initialValue="email"
        >
          <Radio.Group>
            <Radio value="email">ইমেইল</Radio>
            <Radio value="phone">মোবাইল নম্বর</Radio>
          </Radio.Group>
        </Form.Item>
        <div className="mt-2 text-gray-500 font-medium">
          <p className="flex items-center gap-1">
            <span className="font-roboto">OTP</span>{" "}
            <span className="mt-0.5">পাঠানো হবে: </span>
            <span className="font-roboto">
              {selectedChannel === "phone" ? phone : email}
            </span>
          </p>
        </div>

        <Flex justify="end" gap={16} className="mt-8">
          <Button disabled={isLoading} onClick={onClose}>
            বাতিল
          </Button>
          <Button loading={isLoading} type="primary" htmlType="submit">
            সাবমিট
          </Button>
        </Flex>
      </Form>
    </CustomModal>
  );
}
